import { ListType } from 'src/service/creation';

export type StudioList = ListType[];

export enum EditorMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
